import ContentRestrictiveDesigner from './ContentRestrictiveDesigner';
import { ContentRestrictiveDefinitions } from './ContentRestrictiveDefinitions';

export class ContentRestrictive extends ContentRestrictiveDefinitions {
    render() {

        return (
            <div
                data-schema-id={this.props.id}
                className={`fa-draggable fa-Section row ${this.props.designing ? "designing" : ""}`}
                style={{
                    minHeight: this.props.designing ? "200px" : "auto",
                    position: "relative",
                }}
            >
                {this.props.designing ? (
                    <ContentRestrictiveDesigner {...this.props} />
                ) : (
                    this.props.children
                )}
            </div>
        );
    }
}

